import React from 'react'
import { ErrorMessage, Link } from '@sketch/components'
import { ReactComponent as ExclamationMarkTriangleIcon } from '@sketch/icons/exclamation-mark-triangle-64'

type PrototypeErrorStatusProps = {
  title?: string
}

/**
 * Shows an error view for the Prototype. Intended to replace the main Prototype
 * content and take over the whole view.
 */
export function PrototypeErrorStatus(props: PrototypeErrorStatusProps) {
  const { title = 'Prototype Error' } = props
  return (
    <ErrorMessage
      dark
      iconSize="medium"
      icon={<ExclamationMarkTriangleIcon />}
      title={title}
      description={
        <>
          {"We're looking into the issue. Try again later or visit our "}
          <Link
            variant="quaternary"
            external={true}
            isUnderlined={true}
            title="Sketch status page"
            href="https://status.sketch.com/"
          >
            Status Page
          </Link>
          .
        </>
      }
    />
  )
}
